import React, { Component, PropTypes } from 'react';

import {
  ColumnBold,
  TransformText,
  GriddleAction,
  GridHeaderComponent
} from '../../../../components/utils/TableUtils';

import { NitroDataGrid } from 'nitro-components';

class DriverAllocationGrid extends Component {
  // Column definition for Driver allocation datagrid
  getColumnMetaData() {
    const columnMeta = [
      {
        columnName: 'RegistrationNumber',
        displayName: 'Registration',
        sortable: true,
        customComponent: TransformText,
        customHeaderComponent: GridHeaderComponent
      },
      {
        columnName: 'MakeName',
        displayName: 'Make',
        sortable: true,
        customComponent: TransformText,
        customHeaderComponent: GridHeaderComponent
      },
      {
        columnName: 'ModelName',
        displayName: 'Model',
        sortable: true,
        customComponent: TransformText,
        customHeaderComponent: GridHeaderComponent
      },
      {
        columnName: 'LeaseId',
        displayName: 'Lease ID',
        sortable: true,
        customHeaderComponent: GridHeaderComponent
      },
      {
        columnName: 'LeaseDescription',
        displayName: 'Lease Type',
        sortable: false,
        customHeaderComponent: GridHeaderComponent
      },
      {
        columnName: 'DriverFirstName',
        displayName: 'Driver',
        sortable: true,
        customHeaderComponent: GridHeaderComponent,
        customComponent: ({ data, rowData }) => (
          <span>
            {data} {rowData.DriverSurname}
          </span>
        )
      },
      {
        columnName: 'MoreDetails',
        displayName: '  ',
        sortable: false,
        customComponent: () => <GriddleAction content={'Change Allocation'} />
      }
    ];

    return columnMeta;
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Force an update if data is coming for the first time
    return Boolean(!this.props.data.length && nextProps.data.length) || !nextProps.shouldNotReRender;
  }

  render() {
    return (
      <NitroDataGrid
        results={this.props.data}
        totalCount={this.props.total}
        rowPerPage={this.props.rowCount}
        columnMetaData={this.getColumnMetaData()}
        onRowClick={this.props.onRowClick}
        fetchExternalData={this.props.getExternalData}
        currentPage={this.props.currentPage}
        dataFetching={this.props.dataFetching}
        sortColumnAscendingCls="sort-column-ascending"
        sortColumnDescendingCls="sort-column-descending"
      />
    );
  }
}

DriverAllocationGrid.propTypes = {
  data: PropTypes.array,
  total: PropTypes.number,
  rowCount: PropTypes.number,
  getExternalData: PropTypes.func,
  onRowClick: PropTypes.func,
  currentPage: PropTypes.number,
  dataFetching: PropTypes.bool,
  shouldNotReRender: PropTypes.bool
};

export default DriverAllocationGrid;



// WEBPACK FOOTER //
// ./src/features/relocations/driver/components/DriverAllocationGrid.js